// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".demo-app-pdf-preview {\n  height: 100%;\n}\n.demo-app-excel-preview {\n  padding-right: 30px;\n}\n", "",{"version":3,"sources":["webpack://src/modules/data_crafter_app/components/DocumentPreview/DocumentPreview.less"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".demo-app-pdf-preview {\n  height: 100%;\n}\n.demo-app-excel-preview {\n  padding-right: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
